import _Box from "@alifd/next/es/box";
import _Input from "@alifd/next/es/input";
import _Switch from "@alifd/next/es/switch";
import React, { useState } from 'react';
import './index.scss';
var TitleSetter = function TitleSetter(props) {
  var _target$getHotValue;
  var value = props.value,
    defaultValue = props.defaultValue,
    defaultChecked = props.defaultChecked,
    onChange = props.onChange,
    field = props.field,
    prop = props.prop;
  var _useState = useState(defaultChecked),
    checked = _useState[0],
    setChecked = _useState[1];
  var target = field || prop;
  var theVal = (target === null || target === void 0 ? void 0 : (_target$getHotValue = target.getHotValue) === null || _target$getHotValue === void 0 ? void 0 : _target$getHotValue.call(target)) || defaultValue || value;
  var handleToggle = function handleToggle(vis) {
    onChange === null || onChange === void 0 ? void 0 : onChange(vis ? theVal : '');
    setChecked(vis);
  };
  var handleChangeText = function handleChangeText(text) {
    onChange === null || onChange === void 0 ? void 0 : onChange(text);
  };
  return /*#__PURE__*/React.createElement(_Box, {
    className: "setter-title",
    direction: "row",
    align: "center",
    spacing: 10
  }, /*#__PURE__*/React.createElement(_Switch, {
    size: "small",
    checked: checked,
    onChange: handleToggle
  }), checked && /*#__PURE__*/React.createElement(_Input, {
    size: "small",
    value: theVal,
    onChange: handleChangeText
  }));
};
export default TitleSetter;